/* ════════════════════════════════════════════════════════════════════════════
 * LES OFFRES DE LA VITRINE — SOURCE UNIQUE DES TRANCHES D'EFFECTIF
 * ════════════════════════════════════════════════════════════════════════════
 *
 * ⛔ LES BORNES NE S'ÉCRIVENT QU'ICI. Les cartes d'offres ET le menu « Nombre
 *    d'agents approximatif » en sont générés. *Deux listes écrites à la main,
 *    c'est le jour où l'une dit « 1 à 30 » et l'autre « 1 à 25 » — ce qui est
 *    exactement arrivé, et ce que ce lot répare.* Le menu portait
 *    1-30 / 31-100 / 101-200 / 200+ ; les cartes, les vraies bornes.
 *
 * ⚠️ LA VÉRITÉ EST EN BASE : `public.grille_tarifaire.effectif_min/effectif_max`,
 *    la table que lit la FACTURATION. Ce module en est le **miroir**, et il est
 *    tenu par `GARDE (78)`, qui compare les deux et REFUSE le déploiement en cas
 *    de divergence. *Un miroir sans garde est une deuxième vérité.*
 *
 * ⚠️ POURQUOI UN MIROIR ET PAS UNE REQUÊTE. Deux raisons mesurées le 22/10/2026 :
 *    ① **il n'y a pas de « pays du visiteur »** — la vitrine est celle de
 *      l'ÉDITEUR, pour toute la zone OHADA ; et la grille diffère par pays :
 *      **TG porte les quatre offres, BJ et CM n'en portent que trois** (pas de
 *      ligne `elite_plus`). Charger « la grille » ferait disparaître ELITE+ au
 *      nom d'un pays que personne n'a choisi ;
 *    ② la page publique doit s'afficher sans attendre le réseau.
 *    ➡️ Côté SERVEUR, aucune constante : il valide ce qu'il reçoit CONTRE la
 *       grille — il a la base sous la main (`superAdminController.creerDemandeDemo`).
 *
 * ⓘ `aPartirDe` et `parAgent` sont ici parce qu'ils SONT les bornes tarifaires de
 *   la même ligne de grille. Ce qui reste dans la carte, c'est ce qui n'est que
 *   de la présentation : les exemples chiffrés et le badge.
 * ════════════════════════════════════════════════════════════════════════════
 */

export const OFFRES = [
  { code: 'ALPHA', min: 1, max: 25, aPartirDe: '40 000', parAgent: '2 000' },
  { code: 'VANGUARD', min: 26, max: 100, aPartirDe: '50 000', parAgent: '1 500' },
  { code: 'ELITE', min: 101, max: 200, aPartirDe: '150 000', parAgent: '1 200' },
  /* ELITE+ : point d'entrée annoncé, prix négocié — pas de prix unitaire. */
  { code: 'ELITE+', min: 201, max: null, aPartirDe: '240 000', parAgent: null },
];

/**
 * Le libellé d'une tranche, DÉRIVÉ de ses bornes — jamais recopié.
 * « 1 à 25 agents » · « 201 agents et plus »
 * ⚠️ C'est aussi la valeur ENVOYÉE au serveur et STOCKÉE : le serveur la
 *    reconstruit depuis la grille et compare. Changer cette forme sans changer
 *    la reconstruction côté serveur ferait refuser toutes les demandes — d'où
 *    la recette qui éprouve les deux ensemble.
 */
export const libelleTranche = (o) => (
  o.max === null ? `${o.min} agents et plus` : `${o.min} à ${o.max} agents`
);

/** Toutes les tranches, dans l'ordre des bornes. */
export const TRANCHES = OFFRES.map(libelleTranche);

/**
 * L'offre QUI CORRESPOND à une tranche choisie, ou `null` si rien n'est choisi.
 * ⛔ C'est le seul chemin par lequel une offre est associée à une demande. Le
 *    formulaire ne propose plus de CHOISIR une offre : deux menus indépendants
 *    laissaient demander ELITE+ pour dix agents, et le serveur l'acceptait.
 *    *La contradiction n'est plus interdite par un contrôle : elle est devenue
 *    impossible.*
 */
export const offrePourTranche = (valeur) => (
  OFFRES.find((o) => libelleTranche(o) === valeur) || null
);

/**
 * L'offre qui correspond à un NOMBRE d'agents — pour la recette et pour un
 * futur champ numérique. Même règle de bornes que `horsBornes()` du serveur :
 * `min <= n <= max`, `max === null` valant l'infini.
 */
export const offrePourEffectif = (n) => {
  const x = Number(n);
  if (!Number.isFinite(x)) return null;
  return OFFRES.find((o) => x >= o.min && (o.max === null || x <= o.max)) || null;
};
